// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1050":"e87f7109","2639":"7996dc85","4229":"e87f7109","4758":"6657bf60","6822":"f106f798","8731":"bfea45d7","8888":"e87f7109","9658":"bfea45d7"}[chunkId] + ".chunk.css";
};